import { Api } from '../api/api';
import { Injectable } from '@angular/core';
import {LocalDataSource} from '../../ng2-smart-table/lib/data-source/local/local.data-source';
import {AlertData} from '../../interfaces/alert-data';

@Injectable()
export class OpenCaseProvider {

  openCaseData: Array<any> = [];
  tableData: LocalDataSource = new LocalDataSource();

  constructor(public api: Api) {

  }

  query(isTechnical) {
      this.openCaseData = [];
      const route = isTechnical ? 'Technical' : '';
      return this.api.get('openCase' + route);
  }

  setOpenCase(_alert: AlertData, isTechnical: boolean): Promise<any> {

    const route = isTechnical ? 'Technical' : '';
    _alert.editorPerson = this.api._user.profile.firstname + ' ' + this.api._user.profile.lastname;
    const alertFirstName = _alert.firstname;
    const alertLastName = _alert.lastname;

    return new Promise((resolve, reject) => {
      this.api.get('alertDoc' + route, {docId: _alert._id}).subscribe((checkResp: any) => {
        if (checkResp.data.data.data.inProgress === false) {

          this.api.put('openCase' + route, {body: _alert}).subscribe({next:(response: any) => {
              this.api.get('alertDoc' + route, {docId: response.data.data.data.id}).subscribe({next:(doc: any) => {
                _alert = doc.data.data.data;
                _alert.firstname = alertFirstName;
                _alert.lastname = alertLastName;
                resolve(_alert);
              }, error:(err) => {
                console.log(err);
                reject(err);
              }});

            }, error: (err) => {
              console.log(err);
              reject(err);
            }});

          } else {
            reject({error: {data: {code: 'ERRINPROGRESS'}}});
          }
        });
    });
  }

  add(alertData: AlertData) {
    this.tableData.append(alertData);
  }

}
